module.exports = __webpack_public_path__ + "static/wallpaper-d737c672cf7193dbf709b825ea681376.jpg";